import '../../Assets/Styles/home.css';

import TagManager from 'react-gtm-module'

import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { TabView, TabPanel } from 'primereact/tabview';

import { AutoComplete } from 'primereact/autocomplete';
import { Dropdown } from 'primereact/dropdown';
import Grid from '@mui/material/Grid';

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as PartnerActions from '../../Store/Actions/Partner';

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import FaqView from '../../Components/Partner/Faq';
import AlertView from '../../Components/AlertModal';

// Search Views
import ModalSearchClinic from './ModalSearchClinic';

// Set assets
import backgroundPartnerHome from '../../Assets/Images/backgroundHomeRes.png';
import backgroundHomeResMobile from '../../Assets/Images/backgroundHomeResMobile.png';
import backgroundHomeFullBlock1 from '../../Assets/Images/backgroundHomeFullBlock1.png';
import backgroundHomeBlock1 from '../../Assets/Images/backgroundHomeBlock1.png';

import backgroundHomeFullBlock1Mobile from '../../Assets/Images/backgroundHomeFullBlock1Mobile.png';
import backgroundHomeBlock1Mobile from '../../Assets/Images/backgroundHomeBlock1Mobile.png';

import screeningImage from '../../Assets/Images/screeningImage.png';
import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 

import iconHandMoney from '../../Assets/Images/iconHandMoney.svg';
import iconReorder from '../../Assets/Images/iconReorder.svg';
import iconSale from '../../Assets/Images/iconSale.svg';

import iconServiceClinicActive from '../../Assets/Images/iconServiceClinic.svg';
import iconServiceClinicInactive from '../../Assets/Images/iconServiceClinicOff.svg';

import iconServiceOpticsActive from '../../Assets/Images/iconServiceOptics.svg';
import iconServiceOpticsInactive from '../../Assets/Images/iconServiceOpticsOff.svg';

import blogImage from '../../Assets/Images/blogImage.png';
import blogImage2 from '../../Assets/Images/blogImage2.png';
import blogImage3 from '../../Assets/Images/blogImage3.png';
import blogImage4 from '../../Assets/Images/blogImage4.png';

import logoClinic1 from '../../Assets/Images/logoClinic1.jpg';
import logoClinic2 from '../../Assets/Images/logoClinic2.jpg';

import imageFallback from '../../Assets/Images/imagePlaceholder.jpg'; 

import {
	getSlugWithId,
	handleClickScroll
} from '../../Components/Utils';

const servicesOfferedArray = [
	{nome:"Consulta com oftalmologista", obrigatorio: true },
	{nome:"Consulta familiar com oftalmologista", obrigatorio: false },
	{nome:"Consulta com especialista em retina", obrigatorio: false },
	{nome:"Consulta com especialista em córnea", obrigatorio: false },
	{nome:"Cirurgia de catarata", obrigatorio: false },
	{nome:"Cirurgia de glaucoma", obrigatorio: false },
	{nome:"Cirurgia de cirurgia refrativa", obrigatorio: false },
  ];

  const discountsOfferedArray = [
	{nome:"Desconto de 10%", obrigatorio: true },
  ];

const HomePage = (props) => {
	
// Set var from props
const {
	setDialog,
	setLoginStatus,
	loginStatus,
	currentCompanyStatus,
	activationStatus,
	setActivationStatus,
	retrieveAppAddressGooglePlaces,
	retrieveAppAddressGoogleCoordinates,
	retrieveCompanyServices,
    retrieveCompanyDiscounts,
    servicesList,
    discountsList	
} = props;


const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

// set Use of history for PUSH 
var navigate = useNavigate();
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
	
const [indexAtivo, setIndexAtivo] = React.useState(0); // 0 - clinics -- 1 - optics
const [selectedService, setSelectedService] = React.useState(null); // 0 - clinics -- 1 - optics
const [selectedDiscount, setSelectedDiscount] = React.useState("Desconto de 10%"); // 0 - clinics -- 1 - optics
const [address, setAddress] = React.useState(null);
const [addressObj, setAddressObj] = React.useState(null);
const [suggestions, setSuggestions] = React.useState(null);
const [loadingSuggestions, setLoadingSuggestions] = React.useState(false);

const [addressSelected, setAddressSelected] = React.useState(false);
const [coordinates, setCoordinates] = React.useState(null);

const [loading, setLoading] = React.useState(false);
const typingTimeoutRef = React.useRef(null);

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = React.useState(null);

const DEBOUNCE_DELAY_MS = 500; // Buffer de espera

// Blog news 
const [noticias, setNoticias] = React.useState([]);
const [noticiasMidia, setNoticiasMidia] = React.useState([]);
const [type, setType] = React.useState('clinic');


const searchAddress = (event) => {
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
  
    if (!event.query || event.query.length < 3) {
      setSuggestions([]);
      return;
    }
  
    typingTimeoutRef.current = setTimeout(() => {
      setLoadingSuggestions(true);
  
      retrieveAppAddressGooglePlaces({ keyword: event.query }, {
        setItems: (items) => {
          setSuggestions(items);
          setLoadingSuggestions(false);
        },
        setError: (message) => {
          setSuggestions([]);
          setLoadingSuggestions(false);
          if (setAlert && setAlertTitle && setAlertBody) {
            setAlertTitle('Erro ao buscar endereço');
            setAlertBody(message || 'Não conseguimos buscar o endereço. Tente novamente.');
            setAlert(true);
          }
        }
      });
    }, DEBOUNCE_DELAY_MS);
  };

  const handleAddressSelect = async (e) => {
	const selected = e.value;
  
	setAddress(selected.description || '');
	setAddressObj(selected || {});
  
	setAddressSelected(true);

	// 🔥 Buscar coordenadas após preenchimento
	await buscarCoordenadasGoogle(selected.description);

  };

  const buscarCoordenadasGoogle = async (address) => {
	try {
	  await props.retrieveAppAddressGoogleCoordinates(
		{ address: address },
		{
		  onSuccess: (data) => {
			if (data.lat && data.lng) {
			  const coordinates = {
				lat: data.lat,
				lng: data.lng
			  };
			  setCoordinates(coordinates);			  
			}
		  },
		  onError: (message) => {
			console.error('Erro ao buscar coordenadas:', message);
            setAlertTitle('Endereço inválido');
            setAlertBody('O endereço fornecido não é válido. Verifique o número do endereço, limpe a busca e faça nova busca.');
            setAlert(true);
		  }
		}
	  );
	} catch (error) {
	  console.error('Erro inesperado ao buscar coordenadas:', error);
	}
  };

  const handleAddressChange = (e) => {
    const value = e.value;
	setAddress(value);
    if (!value) {
      limparCamposEndereco();
    }
  };

  const limparCamposEndereco = () => {
	setAddress('');
	setAddressObj({});
	setAddressSelected(false);
  };  
  
const handleSearch = (type) => {

	const searchType = (type != 'clinic') ? "optics" : "clinic";
	setType(searchType);

	setDialog("MapSearchClinicViewModal",true);

}

// Função para buscar posts
React.useEffect(() => {
	
	const buscarPosts = async () => {
		try {

			const catRes = await fetch('https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/categories?slug=midia');
			const catData = await catRes.json();
			const catId = catData[0]?.id;
  
			let url = `https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/posts?_embed&per_page=4&categories_exclude=${catId}&orderby=date&order=desc`;

			const res = await fetch(url);
			const data = await res.json();
			setNoticias(data);
		} catch (err) {
			console.error('Erro ao buscar posts:', err);
		}
	};

	const buscarPostsMidia = async () => {
		try {
			let url = 'https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/posts?_embed&per_page=4&orderby=date&order=desc&categories=18';
			const res = await fetch(url);
			const data = await res.json();
			setNoticiasMidia(data);
		} catch (err) {
			console.error('Erro ao buscar posts:', err);
		}
	}
	buscarPosts();
	buscarPostsMidia();
	window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);


const tab1HeaderTemplate = (options) => {
	return (
		<div className="tabItem flex-row align-items-center justify-center" style={{padding:"1rem", gap:"1rem",cursor: 'pointer' }} onClick={options.onClick}>
			<img src={indexAtivo === 0 ? iconServiceClinicActive : iconServiceClinicInactive} className="noSelect tabIcon" />
			<span className={indexAtivo === 0 ? "tabLabel active" : "tabLabel inactive"}>Médicos e Clínicas</span>
		</div>
	);
};
 
const tab2HeaderTemplate = (options) => {
	return (
		<div className=" tabItem flex-row align-items-center justify-center" style={{padding:"1rem", gap:"1rem",cursor: 'pointer' }} onClick={options.onClick}>
			<img src={indexAtivo === 1 ? iconServiceOpticsActive : iconServiceOpticsInactive} className="noSelect tabIcon" />
			<span className={indexAtivo === 1 ? "tabLabel active" : "tabLabel inactive"}>Óticas</span>
		</div> 
	)
};

// Função para lidar com o clique na postagem
const handleClick = (noticia) => {
	const url = getSlugWithId(noticia.title?.rendered, noticia.id);
	navigate(url);
};

  /* Load form data */
  React.useEffect(() => {
	retrieveCompanyServices();
	retrieveCompanyDiscounts();
  }, []);


const handleEventAppClick = (eventName) => {
  TagManager.dataLayer({
	dataLayer: {
	  event: eventName,
	  category: 'Evento Conversao'
	}
  });
};


// If not logged, show login screen
  return (
	<>
	<div id="homeMainSection" className={isMobile ? "wrapper_home__content" : "wrapper_home__content"} >

		<img src={isMobile ? backgroundHomeResMobile : backgroundPartnerHome} className="wrapper_home__content_bgPhoto blockImage1" />

		<HeaderView />

		<div className={isMobile ? "mobileWrapperBox wrapper_home__content_container" : "wrapper_home__content_container"} style={{paddingTop:"1.5rem"}}> 
		

			{/*<!-- Webdoor Slogan and descriptiob + CTA -->*/}
			<div id="searchBox" className="wrapper_home__content_container_block" style={{height:isMobile ? "40rem" : "22rem"}}>  

				
				<div className="wrapper_home__content_container_webdoor">

					<div className="w100 tAlignL"><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
					<div className="wrapper_home__content_container_webdoor_title"><span className="noBold">A</span> saúde ocular <span className="noBold">chegou</span> para todos.</div>	
					<div className="wrapper_home__content_container_webdoor_description">A Estação do Olho é uma iniciativa que conecta você às melhores clínicas e médicos para consultas, exames e cirurgias, pagando menos.</div>
				</div>

			</div>	

			{/*<!-- Service Selector -->*/}
			<div className="wrapper_home__content_container_block" style={{height: isMobile ? "unset" : "13rem"}}>  
				
				<div className="wrapper_home__content_container_selector">

					<div className="wrapper_home__content_container_selector_top">
						<div className="label">Você esta buscando por:</div>
						<div className="flex-1_5 tabsWrapper">

							<TabView className="tabSelector" activeIndex={indexAtivo} onTabChange={(e) => setIndexAtivo(e.index)}>
								<TabPanel header="Médicos e Clínicas" headerTemplate={tab1HeaderTemplate} />
								<TabPanel header="Óticas" headerTemplate={tab2HeaderTemplate} />
							</TabView>

						</div>
					</div>	
					<div className="wrapper_home__content_container_selector_bottom">

						{/* Conteúdo separado */}
						<div className={isMobile ? "w100 flex-column justify-center align-items-center" : "w100 flex-row justify-center align-items-center"} style={{ gap: '1rem',paddingLeft:isMobile ? "1rem" : "2rem",paddingRight:isMobile ? "1rem" : "2rem" }}>
							{indexAtivo === 0 && (<>
								<div style={{width:isMobile ? "100%" : "20rem"}}>
								<Grid container spacing={0}>
									<Grid item xs={12} sm={12}>
										<div className="w100 tAlignL formControlAlt">
											<label htmlFor="servicesOffered" className="serviceSelectorLabel">Serviço desejado <span className="requiredField">*</span></label>
											<Dropdown
											id="selectedService"
											tabIndex={6} 
											value={selectedService}
											options={servicesList?.map(s => ({ label: s.name, value: s.id }))}
											optionLabel="label"
											optionValue="value"											
											onChange={(e) => {setSelectedService(e.value)}}
											placeholder="Selecione um serviço"
											className="w100 serviceSelectorDropdown"
											/>
										</div>
									</Grid>
								</Grid>	
								</div>
								<div className={isMobile ? "w100 flex-1" : "flex-1"} style={{marginBottom:isMobile ? "2rem" : "unset"}}>
								<Grid container spacing={0}>
									<Grid item xs={12}>
										<div className={isMobile ? "w100 tAlignL formControl flex-column justify-center items-align-center" : "w100 tAlignL formControl flex-row justify-center items-align-start"} style={{ position: 'relative',paddingRight:isMobile ? "unset" : "2rem",paddingLeft:isMobile ? "unset" : "2rem",gap:"0.5rem" }}>
											<div className='w100'>
												<label htmlFor="address" className="serviceSelectorLabel">Endereço <span className="requiredField">*</span></label>
												<AutoComplete
													id="address"
													tabIndex={1} 
													value={address}
													suggestions={suggestions}
													completeMethod={searchAddress}
													field="description"
													onChange={handleAddressChange}
													onSelect={handleAddressSelect}
													onHide={() => {
														if (!addressObj || !addressObj.description) {
														setAddress('');
														}
													}} 													
													className="w100"
													inputClassName="w100 searchInput"
													delay={DEBOUNCE_DELAY_MS}
													minLength={5}               
													placeholder="Comece digitando o seu endereço"
													disabled={loadingSuggestions}
													readOnly={!!addressObj?.description}
													emptyMessage="Nenhum endereço encontrado."
												/>
											</div>
											<div style={{width:isMobile ? "100%":"unset",alignSelf:"flex-end",display:"flex",gap:"0.5rem",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
												{addressObj?.description && 
												<>
													{!isMobile &&
													<>
													<Button
														icon="pi pi-times"
														className="p-button-text searchClean"
														style={{ backgroundColor:"#FFF",color:"#C53F84",marginLeft:"-1.5rem"}}
														onClick={limparCamposEndereco}
														tooltip="Limpar endereço"
														tooltipOptions={{ position: 'left' }}
													/>
													</>
													}

												</>
												}											
												<Button
													label={loading ? "Buscando" : "Buscar clínica"}
													rounded
													disabled={!addressSelected || (indexAtivo === 0 && !selectedService) || (!coordinates)}
													className="pT10 searchButton filled"
													style={{ maxWidth: isMobile ? '100%' : '9.4rem'}}
													loading={loading}
													onClick={!addressSelected ? () => console.log("Buscar") : ()=> {handleSearch('clinic');handleEventAppClick("search_clinic")}}
												/>
												{addressObj?.description && 
												<>
													{isMobile &&
													<>
													<Button
														icon="pi pi-times"
														className="p-button-text searchClean"
														style={{ backgroundColor:"#FFF",color:"#C53F84",marginLeft:"-1.5rem",marginTop:"-8.5rem",height:"3rem"}}
														onClick={limparCamposEndereco}
														tooltip="Limpar endereço"
														tooltipOptions={{ position: 'left' }}
													/>
													</>
													}

												</>
												}													
											</div>										
										</div>
									</Grid>
								</Grid>
								</div>
							</>)}
							{indexAtivo === 1 && (<>
								<div style={{width:isMobile ? "100%" : "20rem"}}>
								<Grid container spacing={0}>
									<Grid item xs={12} sm={12}>
										<div className="w100 tAlignL formControlAlt">
											<label htmlFor="servicesOffered" className="serviceSelectorLabel">Benefício desejado <span className="requiredField">*</span></label>
											<Dropdown
											id="selectedDiscount"
											tabIndex={6} 
											value={selectedDiscount}
											options={discountsList?.map(s => ({ label: s.name, value: s.id }))}
											onChange={(e) => {setSelectedDiscount(e.value)}}
											placeholder="Selecione um benefício"
											className="w100 serviceSelectorDropdown"
											readOnly={true}
											optionLabel="label"
											optionValue="value"											
											/*tooltip="No momento só há uma opção disponível"
											tooltipOptions={{ position: 'bottom' }}	*/										
											/>
										</div>
									</Grid>
								</Grid>	
								</div>							
								<div className={isMobile ? "w100 flex-1" : "flex-1"} style={{marginBottom:isMobile ? "2rem" : "unset"}}>
								<Grid container spacing={0}>
									<Grid item xs={12}>
										<div className={isMobile ? "w100 tAlignL formControl flex-column justify-center items-align-center" : "w100 tAlignL formControl flex-row justify-center items-align-start"} style={{ position: 'relative',paddingRight:isMobile ? "unset" : "2rem",paddingLeft:isMobile ? "unset" : "2rem",gap:"0.5rem" }}>
											<div className='w100'> 
												<label htmlFor="address" className="serviceSelectorLabel">Endereço <span className="requiredField">*</span></label>
												<AutoComplete
													id="address"
													tabIndex={1} 
													value={address}
													suggestions={suggestions}
													completeMethod={searchAddress}
													field="description"
													onChange={handleAddressChange}
													onSelect={handleAddressSelect}
													className="w100"
													inputClassName="w100 searchInput"
													delay={DEBOUNCE_DELAY_MS}
													minLength={5}  
													forceSelection
													placeholder="Comece digitando o seu endereço e selecionando a opção apropriada"
													disabled={loadingSuggestions}
													readOnly={!!addressObj?.description}
													emptyMessage="Nenhum endereço encontrado."
												/>
											</div>
											<div style={{width:isMobile ? "100%":"unset",alignSelf:"flex-end",display:"flex",gap:"0.5rem",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
												{addressObj?.description && 
												<>
													{!isMobile &&
													<>
													<Button
														icon="pi pi-times"
														className="p-button-text searchClean"
														style={{ backgroundColor:"#FFF",color:"#C53F84",marginLeft:"-1.5rem"}}
														onClick={limparCamposEndereco}
														tooltip="Limpar endereço"
														tooltipOptions={{ position: 'left' }}
													/>
													</>
													}

												</>
												}											
												<Button
													label={loading ? "Buscando" : "Buscar ótica"}
													rounded
													disabled={!addressSelected  || (indexAtivo === 1 && !selectedDiscount) }
													className="pT10 searchButton filled"
													style={{ maxWidth: '9.4rem'}}
													loading={loading}
													onClick={!addressSelected ? () => console.log("Buscar") : ()=>{handleSearch('optics');handleEventAppClick("search_optics")}}
												/>
											</div>										
										</div>
									</Grid>
								</Grid>
								</div>
							</>)}
						</div>

					</div>

				</div>

			</div>

			{/*<!-- 3 cards -->*/}
			<div className="wrapper_home__content_container_block">  

				<div className="wrapper_home__content_container_cards" style={{marginTop:"1rem"}}>

					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={iconHandMoney} style={{width:"1.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Saúde visual acessível<br /> com os melhores médicos e clínicas.</div>
						
					</div>

					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={iconReorder} style={{width:"1.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Simples e sem burocracia: Plataforma 100% gratuita,
						sem cadastro ou mensalidade.</div>
					</div>


					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={iconSale} style={{width:"1.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Economia em óticas: À partir de 10% de desconto nas melhores lojas do Rio de Janeiro.</div>
					</div>

				</div>				

			</div>	

		</div>			

		{/*<!-- Why EDO FULL Box -->*/}
		<div className="wrapper_home__content_full_container" style={{marginTop: isMobile ? "0rem" : "-3rem",height:isMobile ? "80rem" : "100rem",overflow:isMobile ? "hidden" : "unset"}}>

			<img src={isMobile ? backgroundHomeBlock1Mobile : backgroundHomeBlock1} className="wrapper_home__content_bgPhoto" style={{top: isMobile ? "29rem" : ""}}/>

			<div className="wrapper_home__content_container_highlight" style={{marginTop:isMobile ? "2rem" : "10rem", paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : ""}}> 

				<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
				<div className="wrapper_home__content_container_highlight_title">Por que Estação do Olho?</div>
				<div className="wrapper_home__content_container_highlight_description">A Estação do Olho conecta você a médicos, clínicas e óticas parceiras de forma simples e acessível. Criada pelos oftalmologistas Gustavo Novais e Bruno Fernandes, nossa missão é democratizar o acesso à saúde ocular, aproximando especialistas e pacientes com qualidade e tecnologia.</div>

				<div className="wrapper_home__content_container_highlight_cta"><Button label="Saiba mais sobre a Estação do Olho" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem",width:"unset"}}  onClick={() => navigate("/quem-somos")} /></div>

			</div>			

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_home__content_container_block flex-column justify-center align-items-center" style={{flex:1,position:"relative"}}>  
				
				<div className="wrapper_home__content_container_highlight porqueEstacaoBlock" style={{marginTop:isMobile ? "20rem" :"36.75rem",paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : ""}}>

					<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
					<div className="wrapper_home__content_container_highlight_title fWhite">Os melhores oftalmologistas em um só lugar!</div>
					<div className="wrapper_home__content_container_highlight_description fWhite">Conectamos você a uma rede de clínicas, médicos e óticas de confiança, oferecendo<br />diversas opções de atendimento acessíveis e de qualidade.</div>

					<div className="wrapper_home__content_container_highlight_cta"><Button label="Busque uma clínica agora" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem"}}  onClick={() => handleClickScroll('searchBox')} /></div>

				</div>	

				{/*<!-- Clinics logos -->*/}
				{/*<div className="wrapper_home__content_container_logoCards" style={{flexWrap:"wrap",marginTop:"3.5rem",width:"100%",maxWidth:"69rem"}}>

					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic1} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Eye Clinic</div>
					</div>


					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic2} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Visão Certa</div>
					</div>


					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic1} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Visionnaire</div>
					</div>

					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic2} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Eye Town</div>
					</div>

					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic1} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Eye Clinic</div>
					</div>


					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic2} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Visão Certa</div>
					</div>


					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic1} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Visionnaire</div>
					</div>

					<div className="card cardScreening">
						<div className="cardScreening__icon"><img src={logoClinic2} style={{width:"3.5rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Eye Town</div>
					</div>					


				</div>	*/}				

			</div>


		</div>

		{/*<!-- More blocks -->*/}
		<div className="wrapper_home__content_container" style={{paddingTop:"1.5rem"}}>


			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_home__content_container_block flex-row justify-center align-items-end" style={{flex:1}}>  
				
				<div className="wrapper_home__content_container_diferencialbox" style={{flexDirection:isMobile ? "column" : "",gap: isMobile ? "1rem" : ""}}>

					<div className="wrapper_home__content_container_screeningbox_right"> 
						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>						
						<div className="title">Estação de Triagem Ocular Gratuita</div>						
						<div className="text">
						Estação do Olho é sinônimo de prevenção e impacto social!<br /><br />

						Concluímos com sucesso a primeira temporada de triagens oculares gratuitas em nossa Estação no Shopping Nova América. Em poucos meses, atendemos mais de 4.000 pessoas, identificando problemas oculares em estágios iniciais e possibilitando o encaminhamento para diagnóstico e tratamento.<br /><br />

						Fique de olho nas nossas redes e aguarde novidades sobre a data e o local da segunda temporada de triagens!
						</div>																	
					</div>			

					<div className="wrapper_home__content_container_screeningbox_left"> 
						<div className="image"><img src={screeningImage} style={{width:"100%",height:"auto"}} /></div>
					</div>							
	
				</div>
			</div>
			

		</div>

		{/*<!-- Diferencial FULL Box -->*/}
		<div className="wrapper_home__content_full_container" style={{marginTop:"1.24rem",mingHeight:"45rem",overflow:"hidden"}}> 
			<img src={isMobile ? backgroundHomeFullBlock1Mobile : backgroundHomeFullBlock1} className="wrapper_home__content_bgPhoto" style={{minHeight:"608px"}} />

			{/*<!-- Blog Highlight with 4 cards -->*/}
			<div className="wrapper_home__content_container_block">  

				<div className="wrapper_home__content_container_highlight" style={{paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : "",marginTop:"6.5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_home__content_container_highlight_title fWhite">Estação do Olho na Mídia</div>
						<div className="wrapper_home__content_container_highlight_description fWhite">Nosso impacto na saúde ocular já foi destaque em diversas publicações. Confira!</div>

				</div>

				<div className="wrapper_home__content_container_cards wrapper_home__content_container_cardsBlog" style={{flexWrap:"nowrap",marginTop:"3.5rem"}}>

					{noticiasMidia.map(post => {
						
						const midia = post._embedded?.['wp:featuredmedia']?.[0];
						const image = midia?.media_details?.sizes?.medium?.source_url
						|| midia?.media_details?.sizes?.thumbnail?.source_url
						|| midia?.source_url;	

						//const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';

						const categories = post._embedded?.['wp:term']?.[0] || [];

						// Função para remover acentos
						const sanitize = (str) => {
						  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
						};						

						return (
							<div key={post.id} className="card cardBlog applyPointer" onClick={() => handleClick(post)}>
							<div className="cardBlog__image">
								<img src={image || imageFallback} className="noSelect" alt={post.title.rendered}   onError={(e) => { 
									e.target.onerror = null; // evita loop infinito
									e.target.src = imageFallback;
								}} />
							</div>
							<div className="cardBlog__category media">

								{categories.map((cat, idx) => (
									<span key={idx} className={sanitize(cat.name)}>{cat.name}</span>
								))}	

								{categories.length == 0 && (
									<span className="semCategoria">Sem categoria</span>
								)}

							</div>
							<div className="cardBlog__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
							<div className="cardBlog__description" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
							</div>
						);
					})}	

					{/*<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage} className="noSelect" /></div>
						<div className="cardBlog__category media"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Acidentes oculares em esportes</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage2} className="noSelect" /></div>
						<div className="cardBlog__category media"><span>Na Mídia</span></div>
						<div className="cardBlog__title">O Impacto da Anemia na Saúde Ocular</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage3} className="noSelect" /></div>
						<div className="cardBlog__category media"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Os Desafios Visuais do Albinismo</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage4} className="noSelect" /></div>
						<div className="cardBlog__category media"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Mês de Conscientização sobre o Autismo</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>		*/}													


				</div>		

				<div className="wrapper_home__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"5.31rem"}}><Button label="Encontre um especialista" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem"}} onClick={() => handleClickScroll('searchBox')} /></div>

			</div>	


		</div>


		{/*<!-- FAQ FULL box -->*/}
		<div className="wrapper_home__content_full_container" style={{backgroundColor:'#FFFFFF',marginTop:"0",mingHeight:"45rem",overflow:"hidden"}}> 
		

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_home__content_container_block flex-row justify-center align-items-end" style={{flex:1}}>  
				
				<div className="wrapper_home__content_container_diferencialbox">

					<FaqView whiteBackground={true} mTop="0" />	
	
				</div>

			</div>

		</div>

		{/*<!-- Blog Highlights BOX -->*/}
		<div className="wrapper_home__content_container"> 
		
			{/*<!-- Blog Highlight with 4 cards -->*/}
			<div className="wrapper_home__content_container_block">  

				<div className="wrapper_home__content_container_highlight" style={{paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : "",marginTop:"6.5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_home__content_container_highlight_title">Tudo sobre saúde ocular em um só lugar!</div>
						<div className="wrapper_home__content_container_highlight_description">Leia artigos sobre visão, bem-estar e as melhores práticas para cuidar da sua saúde ocular.</div>

				</div>

				<div className="wrapper_home__content_container_cards wrapper_home__content_container_cardsBlog" style={{flexWrap:"nowrap",marginTop:"3.5rem"}}>

					{noticias.map(post => {
						
						const midia = post._embedded?.['wp:featuredmedia']?.[0];
						const image = midia?.media_details?.sizes?.medium?.source_url
						|| midia?.media_details?.sizes?.thumbnail?.source_url
						|| midia?.source_url;	

						//const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';

						const categories = post._embedded?.['wp:term']?.[0] || [];

						// Função para remover acentos
						const sanitize = (str) => {
						  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
						};						

						return (
							<div key={post.id} className="card cardBlog applyPointer" onClick={() => handleClick(post)}>
							<div className="cardBlog__image">
								<img src={image || imageFallback} className="noSelect" alt={post.title.rendered}   onError={(e) => { 
									e.target.onerror = null; // evita loop infinito
									e.target.src = imageFallback;
								}} />
							</div>
							<div className="cardBlog__category" style={{gap:"0.5rem"}}>

								{categories.slice(0, 3).map((cat, idx) => (
									<span key={idx} className={sanitize(cat.name)}>{cat.name}</span>
								))}	

								{categories.length == 0 && (
									<span className="semCategoria">Sem categoria</span>
								)}

							</div>
							<div className="cardBlog__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
							<div className="cardBlog__description" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
							</div>
						);
					})}			

					{/*<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Acidentes oculares em esportes</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage2} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">O Impacto da Anemia na Saúde Ocular</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage3} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Os Desafios Visuais do Albinismo</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage4} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Mês de Conscientização sobre o Autismo</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>				*/}											


				</div>		

				<div className="wrapper_home__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"7.31rem"}}><Button label="Veja mais em nosso blog" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem"}} onClick={()=>navigate("/noticias")}  /></div>

			</div>	
		
		</div>


	</div>

	  <AlertView
		alert={alert}
		setAlert={setAlert}
		alertTitle={alertTitle}
		alertBody={alertBody}	
		setAlertAction={setAlertAction}
		scrollBlock={false}			
	  />

	 <ModalSearchClinic
		searchType={type}
		selectedService={selectedService}
		selectedDiscount={selectedDiscount}
		address={addressObj}
		coordinates={coordinates}
		scrollBlock={true}	
	 />

	</>
  );
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus,
  servicesList: store.partnerReducer.servicesList,
  discountsList: store.partnerReducer.discountsList
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(HomePage);	


